module.exports = __webpack_public_path__ + "24e004ab/img/pdf-icon.79f04a36.svg";